import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Payment = _resolveComponent("Payment")!
  const _component_CusModal = _resolveComponent("CusModal")!

  return (_openBlock(), _createBlock(_component_CusModal, {
    isShow: _ctx.isShowBuyGoodModal,
    maskClosable: true,
    width: "600px",
    onOnClose: _ctx.hideBuyGoodsModal,
    zIndex: 2999
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Payment, {
        kind: _ctx.buyGoodModalGoodsKind,
        "goods-id": _ctx.buyGoodModalGoodsId,
        gameId: _ctx.buyGoodModalGameId,
        onGotoRecharge: _ctx.gotoRechargeWhenNotEnough
      }, null, 8, ["kind", "goods-id", "gameId", "onGotoRecharge"])
    ]),
    _: 1
  }, 8, ["isShow", "onOnClose"]))
}